// composables/useApi.js
export const useApi = () => { 
  const config = useRuntimeConfig()  
  const authState = useAuthState()

  async function handleUnauthorized() {
    if (import.meta.client) {
      authState.clearAuth()
      localStorage.removeItem("token")
      localStorage.removeItem("userKey")

      const coverGbnCd = sessionStorage.getItem("coverGbnCd");
      const redirectPath = (coverGbnCd === "PCWEB" || coverGbnCd === "MOBWEB") 
        ? "/home"
        : "/home"
      
      console.log("토큰이 없거나 유효시간 만료로 로그인 실패")
      window.location.href = "/view/home";
    }
  }

  async function handleApiError (response, url) {

    // 특정 url + 코드 조합은 호출부에서 처리
    const skipMap = {
      "/api/auth/login": ["0010", "0011"],
      "/api/auth/checkId": ["0020"],
      // 쿠폰 등록 실패 사유는 쿠폰함 화면에서 입력창 아래에 노출
      "/api/promo/createCouponByCode": ["0030", "0031", "0032", "0033", "0035"],
      // 필요할 때 추가
    };

    const skipCodes = skipMap[url] || [];
    if (skipCodes.includes(response.resCd)) return;

    switch (response.resCd) {
      case "9998":
        // alert.value = {
        //   isShow: true,
        //   type: "alert",
        //   title: "로그인이 만료되었습니다.<br>다시 로그인 해주세요.",
        //   onConfirm: () => {
        //     alert.value.isShow = false;
        //     authState.clearAuth()
        //     window.location.href = "/view/login";
        //   },
        // };        
        authState.clearAuth()
        localStorage.removeItem("token")
        localStorage.removeItem("userKey")
        window.location.href = "/view/home";
        break;
      default:
        if (response.resMsg == null || response.resMsg == "") {
          Toast.show("오류가 발생했습니다.");
        } else {
          Toast.show(response.resMsg);
        }
    }
  };

  const api = async (url, data = {}, options = {}) => {
  try {
    
    const headers = {
      'Content-Type': 'application/json',
      ...options.headers,
    }

    const token = authState.token.value
    if (token) {
      headers.Authorization = `Bearer ${token}`
    }

    const apiPath = url.startsWith('/api') ? url : `/api${url}`
    const fullUrl = `${config.public.apiServer}${apiPath}`

    const method = options.method || 'POST';

    console.log('🔍 API 호출:', fullUrl)
    console.log('🔍 Method:', method)
    console.log('🔍 Data:', data)

    const fetchOptions = {
      method: method,
      headers,
      credentials: 'include',
    }

    // ✅ POST/PUT/DELETE는 항상 body 포함 (빈 객체도 전송)
    if (method === 'POST' || method === 'PUT' || method === 'DELETE') {
      fetchOptions.body = JSON.stringify(data || {});
    }

    const response = await fetch(fullUrl, fetchOptions)

    console.log('✅ 응답 상태:', response.status)

    const contentType = response.headers.get('content-type')
    let result

    if (contentType && contentType.includes('application/json')) {
      result = await response.json()
    } else {
      const text = await response.text()
      result = { resCd: '9999', resMsg: text }
    }

    if (response.status === 401 || result.resCd === "UNAUTHORIZED") {
      if (!options.skipErrorHandler) {
        await handleUnauthorized()
        return
      }
      throw new Error('UNAUTHORIZED')
    }

    if (result.resCd === "UNAUTHORIZED") {
      if (!options.skipErrorHandler) {
        await handleUnauthorized()
        return
      }
      throw new Error('UNAUTHORIZED')
    }

    // silent: 부가 기능(로그 기록 등) 호출이 실패해도 사용자에게 오류를 띄우지 않는다
    if (result.resCd !== "0000" && !options.silent) {
      handleApiError(result, apiPath);
    }

    console.log('🔍 result:', result)

    return result

  } catch (error) {
    console.error('❌ API 에러:', error)
    if (error.data) {
      return error.data
    }
    throw error
  }
}
  
  return { api }
}